import EmptyComponent from "./EmptyComponent";

export default EmptyComponent;
